import {
  ITerminalSearch,
  ITerminalStatus,
  IGetTerminalNoPayParams,
} from 'interfaces/terminal';
import commonConstants from 'constants/common';

// BE đã xác nhận để key thuần text (Dương Khánh Nghĩa)
export enum ETerminalStatus {
  CREATED = 'Khởi tạo',
  ACTIVATED = 'Hoạt động',
  LOCKED = 'Khóa',
  WAITING_FOR_APPROVE = 'Chờ duyệt',
  WAITING_FOR_CONTROL_APPROVE = 'Chờ ĐS duyệt',
  REJECTED = 'Từ chối',
  REOPEN = 'Bổ sung hồ sơ',
}

export const TERMINAL_STATUS: { [key: string]: ITerminalStatus } = {
  [ETerminalStatus.CREATED]: {
    text: 'Khởi tạo',
    code: ETerminalStatus.CREATED,
    color: '',
  },
  [ETerminalStatus.ACTIVATED]: {
    text: 'Hoạt động',
    code: ETerminalStatus.ACTIVATED,
    color: '#30CD60',
  },
  [ETerminalStatus.LOCKED]: {
    text: 'Khóa',
    code: ETerminalStatus.LOCKED,
    color: '#434343',
  },
  [ETerminalStatus.WAITING_FOR_APPROVE]: {
    text: 'Chờ duyệt',
    code: ETerminalStatus.WAITING_FOR_APPROVE,
    color: '#46bdc6',
  },
  [ETerminalStatus.WAITING_FOR_CONTROL_APPROVE]: {
    text: 'Chờ ĐS duyệt',
    code: ETerminalStatus.WAITING_FOR_CONTROL_APPROVE,
    color: '#46bdc6',
  },
  [ETerminalStatus.REJECTED]: {
    text: 'Từ chối',
    code: ETerminalStatus.REJECTED,
    color: '#cc0000',
  },
  [ETerminalStatus.REOPEN]: {
    text: 'Bổ sung hồ sơ',
    code: ETerminalStatus.REOPEN,
    color: '#FF4500',
  },
};

export enum EControlStatus {
  REOPEN = 'Chờ bổ sung hồ sơ',
  WAIT_CONTROL = 'Chờ ĐS duyệt ĐT',
  BENEF_WAIT = 'Chờ ĐS duyệt thụ hưởng',
  APPROVED = 'ĐS duyệt',
}

// Phase 2
// COST_SHEET_WAIT = 'Chờ ĐS duyệt phí'

export const CONTROL_STATUS: { [key: string]: any } = {
  [EControlStatus.REOPEN]: {
    text: 'Chờ bổ sung hồ sơ',
    code: EControlStatus.REOPEN,
  },
  [EControlStatus.WAIT_CONTROL]: {
    text: 'Chờ ĐS duyệt ĐT',
    code: EControlStatus.WAIT_CONTROL,
  },
  [EControlStatus.BENEF_WAIT]: {
    text: 'Chờ ĐS duyệt thụ hưởng',
    code: EControlStatus.BENEF_WAIT,
  },
};

const DEFAULT_PAGINATION = {
  page: 1,
  page_size: 10,
};

const DEFAULT_QUERY_PARAMS: ITerminalSearch = {
  ...DEFAULT_PAGINATION,
};

const DEFAULT_QUERY_TER_NOPAY_PARAMS: IGetTerminalNoPayParams = {
  page: 1,
  pageSize: 10,
  serviceIds: [commonConstants.ALL_VALUE],
};

const APPLICATION_SOURCE: {
  [key: string]: { value: string; label: string };
} = {
  SP3: {
    value: 'SP',
    label: 'SP3',
  },
  MO: {
    value: 'MCA',
    label: 'Merchant app',
  },
};

export default {
  ETerminalStatus,
  TERMINAL_STATUS,
  EControlStatus,
  CONTROL_STATUS,
  DEFAULT_QUERY_PARAMS,
  DEFAULT_QUERY_TER_NOPAY_PARAMS,
  APPLICATION_SOURCE,
};
